import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const VdpPaymentCalculatorAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "vdp-payment-calculator" */ './vdp-payment-calculator'),
  componentName: 'VdpPaymentCalculator',
});
